import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            分类浏览
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm">
            五大分类体系，从制度演变、经典影片、影人故事到文化解读与时代回顾
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg aspect-[4/3] cursor-pointer"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/15 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-1.5">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${cat.icon} text-primary-300 text-lg`}></i>
                  </div>
                  <span className="text-xs text-white/70">{cat.articleCount} 篇文章</span>
                </div>
                <h3 className="font-heading text-lg font-bold text-white mb-1">
                  {cat.name}
                </h3>
                <p className="text-sm text-white/70 line-clamp-1">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}